<template>
    <body>
    <div class="container_form">
        <h2>Info about my best friend <span style="font-style: italic;color: gold">{{pet_profile.name}}</span>  </h2>
        <br>
        <label for="petname"><b>Name</b></label>
        <input disabled type="text" placeholder="Pet name..." id="petname"  v-model="this.pet_profile.name" required>

        <label for="breed"><b>The breed of</b></label>
        <input disabled type="text" placeholder="The bread of..." id="breed" v-model="this.pet_profile.breed" required>

        <label for="daten"><b>Birthday</b></label>
        <input disabled type="datetime-local" placeholder="The bread of..." id="daten" v-model="this.pet_profile.daten" required>

        <label for="phistory"><b>History (Adopted, Found, Received, Bought..)</b></label>
        <input disabled type="text" placeholder="Few words about..." id="phistory" v-model="this.pet_profile.phistory" required>

        <label><b>Sex</b>
        </label>
        <br>
        <span v-if="pet_profile.sex === 'male'">
            <input  type="radio"  v-model="this.pet_profile.sex" value="male" required>
            <label>Male</label>
        </span>
        <span v-else>
            <input type="radio"  v-model="this.pet_profile.sex" value="female" required>
            <label>Female</label>
        </span>

        <br><br>
        <label for="petpound"><b> Pound [ kg ] </b></label>
        <input disabled type="number" min="0" id="petpound"  v-model="this.pet_profile.pound" required>

        <br>
        <label for="pmedical"><b>Medical treatment </b></label>
        <input disabled type="text" placeholder="Few words about it..." id="pmedical" v-model="this.pet_profile.medical" required>

        <br><br>
        <label><b>Sterilizer</b>
        </label><br>
        <span v-if="pet_profile.sterilizer === 'yes'">
            <input type="radio"  v-model="this.pet_profile.sterilizer" value="yes" required>
        <label>yes</label>
        </span>
        <span v-else>
            <input type="radio"  v-model="this.pet_profile.sterilizer" value="no" required>
            <label>no</label>
        </span>

        <br><br>
        <label for="pbeheviour"><b>What Behavior has with other animals? </b></label>
        <input disabled type="text" placeholder="Few words about it..." id="pbeheviour" v-model="this.pet_profile.behaviour" required>

        <label for="pwalks"><b>How many walks does he usually take per day? </b></label>
        <input disabled type="number" min="0"  id="pwalks" v-model="this.pet_profile.walks" required>

        <label for="photel"><b>Has he been accommodated so far? </b></label>
        <input disabled type="text" placeholder="Never, yes at .. , yes with friends..." id="photel" v-model="this.pet_profile.hotel" required>

        <label for="pmeals"><b>How many meals does he have per day? </b></label>
        <input disabled type="number" min="0" id="pmeals" v-model="this.pet_profile.meals" required>

        <label for="pfoodq"><b>How much food does he get per day? ( in grams ) </b></label>
        <input disabled type="number" min="0"  id="pfoodq" v-model="this.pet_profile.foodq" required>

        <label for="porder"><b>What is the order? Does he eat and then walk or vice versa? </b></label>
        <input disabled type="text" placeholder="Eat, walk order..." id="porder" v-model="this.pet_profile.order" required>

        <label for="pfed"><b>How is your dog fed? Wet, Dry, Mixed, Cooked, otherwise</b></label>
        <input disabled type="text" placeholder="Wet, dry, mixed..." id="pfed" v-model="this.pet_profile.fedtype" required>

        <label for="penergy"><b>On a scale of 1 to 10 how energetic is your pet? </b></label>
        <input disabled type="number" min="0" max="10"  id="penergy" v-model="this.pet_profile.energy" required>

        <label for="paggresivity"><b>On a scale of 1 to 10, how aggressive is your pet?</b></label>
        <input disabled type="number" min="0" max="10"  id="paggresivity" v-model="this.pet_profile.aggresivity" required>

        <label for="pscare"><b>Does it need special care?</b></label>
        <input disabled type="text" placeholder="Please detail..." id="pscare" v-model="this.pet_profile.scare" required>

        <label for="panxios"><b>Is he anxious if he is left alone in the house?</b></label>
        <input disabled type="text" placeholder="Please detail..." id="panxios" v-model="this.pet_profile.anxios" required>

        <label for="phuman"><b>Does the pet need to be constantly with a human presence?</b></label>
        <input disabled type="text" placeholder="Please detail..." id="phuman" v-model="this.pet_profile.human" required>

        <label for="pdef"><b>Where he know  to defecate ? ( outside/inside/....)</b></label>
        <input disabled type="text" placeholder="Please detail..." id="pdef" v-model="this.pet_profile.defecate" required>

        <label><b>He is not friendly and does not accept the company of other animals</b>
        </label><br>
        <span v-if="pet_profile.friendly === 'yes'">
            <input type="radio"  v-model="this.pet_profile.friendly" value="yes" required>
            <label>yes</label>
        </span>
        <span v-else>
            <input type="radio"  v-model="this.pet_profile.friendly" value="no" required>
            <label>no</label>
        </span>
        <button class="cancelbtn" type="button" @click.prevent="closeForm">Close</button>
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    export default {
        name: 'PetFiles',
        data() {
            return {
                pfid:null,
                baseURL:null,
                pet_profile : {
                    name:'',
                    breed:'',
                    daten: null,
                    sex:'',
                    phistory:'',
                    sterilizer:'',
                    pound:0,
                    medical:'',
                    beheviour:'',
                    walks:0,
                    hotel:'',
                    meals:0,
                    foodq:0,
                    order:'',
                    fedtype:'',
                    energy:0,
                    aggresivity:0,
                    scare:'',
                    anxios:'',
                    human:'',
                    defecate:'',
                    friendly:'',
                }
            }
        },
        mounted() {
            this.pfid = this.$route.params.pfid
            this.baseURL = getBaseURL()
            // get pet form data
            fetch(this.baseURL+'/pets?id='+this.pfid,{
                methods: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }).then( rsp => {
                return rsp.json()
            }).then( data => {
                if(data.length > 0 ) {
                    //found pet form
                    let pf = data[0].info.split('#')
                    // set object info
                    let pet ={
                        name:pf[0],
                        breed:pf[1],
                        daten:pf[2],
                        sex:pf[3],
                        phistory:pf[4],
                        sterilizer:pf[5],
                        pound:pf[6],
                        medical:pf[7],
                        beheviour:pf[8],
                        walks:pf[9],
                        hotel:pf[10],
                        meals:pf[11],
                        foodq:pf[12],
                        order:pf[13],
                        fedtype:pf[14],
                        energy:pf[15],
                        aggresivity:pf[16],
                        scare:pf[17],
                        anxios:pf[18],
                        human:pf[19],
                        defecate:pf[20],
                        friendly:pf[21],
                    }
                    this.pet_profile = pet
                }
            })
        },
        methods: {
            closeForm() {
                this.$router.go(-1)
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        background-color: black;
        color: white;
        height:350vh;
    }
    .container_form {
        padding: 16px 30%;
    }
    input[type=text], input[type=datetime-local] {
        width: 100%;
        padding: 10px 20px;
        margin: 5px 0;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    input[type=number] {
        width: 7em;
        padding: 10px 20px;
        margin_left: 50px;
        display: block;
        border: 1px solid #ccc;
        box-sizing: border-box;
    }
    input:disabled {
        background-color: lightyellow;
    }
    button {
        background-color: dodgerblue;
        color: white;
        padding: 14px 20px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 100%;
        opacity: 0.8;
    }
    button:hover {
        opacity: 1.0;
    }
    button:disabled {
        background-color: darkgray;
    }
    .cancelbtn {
        background-color: crimson;
    }
    @media screen and (max-width: 600px) {
        label {
            font-size: 12px;
        }
        .container_form {
            padding: 16px 15%;
        }
        h2 {
            font-size: 14px;
        }
    }
</style>